import React, { Component } from "react";
import { connect } from "react-redux";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Button, Message, Form, Container, Header, Divider } from "semantic-ui-react";
import { addEmail } from "../../redux/actions"


const AddToMailingList = Yup.object().shape({
  Email: Yup.string()
    .email("Email is inValid")
    .required("Required")
    .trim()
});

const MessageNegative = ({ error }) => (
  <Message negative attached="bottom">
    <Message.Header>Sorry</Message.Header>
    <p>{error}</p>
  </Message>
);

const MessageSuccess = () => (
  <Message
    success
    attached="bottom"
    header="Your email added was successfully"
    content="You will now receive updates to the versions of Zim Waves"
  />
);

class HomeForm extends Component {
  render() {

    const {
      match,
      addEmail,
      isLoading,
      isSaving,
      success,
      error
    } = this.props;

    return (
      <>
        <Container>
          <Header as="h3" textAlign="center">Join the Phykraun Mailing List</Header>
          <Formik
            initialValues={{ Email: "" }}
            validationSchema={AddToMailingList}
            render={({ values, isValid }) => (
              <>
                <Message
                  attached
                  header="Welcome Friend!"
                  content="Fill out the form below to get added to the mailing list"
                />
                <Form

                  className="attached fluid segment"
                  onSubmit={e => {
                    e.preventDefault();
                    const { Email } = values;

                    if ((Email)) {
                      const details = {
                        email: Email
                      }

                      addEmail(details);
                    }
                  }}
                >
                  <Form.Group>
                    <Form.Input
                      label="Enter your email"
                      required
                      inline
                      width="6"
                      error={!isValid}
                    >
                      <Field name="Email" />
                    </Form.Input>
                    <ErrorMessage name="Email" component="div" />
                  </Form.Group>

                  <Divider horizontal />

                  <Button
                    type="submit"
                    positive
                    disabled={!isValid}
                    loading={isLoading || isSaving}
                  >
                    Submit
                    </Button>
                </Form>
              </>
            )}
          />
          {!isLoading && !isSaving && error ? (
            <MessageNegative error={error} />
          ) : null}
          {!isLoading && !isSaving && success ? (
            <MessageSuccess />
          ) : null}
        </Container>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    emails: state.emails.items,
    isLoading: state.emails.addEmailLoading,
    isSaving: state.emails.addEmailSaving,
    success: state.emails.addEmailSuccess,
    error: state.emails.addEmailError
  };
};

const mapDispatchToProps = {
  addEmail
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeForm)
